// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3jSHl","bigColWidth":"Table_bigColWidth__2zsM0","biggerColWidth":"Table_biggerColWidth__2jymG","row":"Table_row__3sF_g","col":"Table_col__Z7a9F"};